export interface MenuItem {
  label: string
  action: string
  shortcut?: string
  separator?: boolean
}

export const WINDOW_MENUS: Record<string, Record<string, MenuItem[]>> = {
  default: {
    File: [
      { label: 'New Window', action: 'new-window', shortcut: '⌘N' },
      { label: 'Close Window', action: 'close-window', shortcut: '⌘W' },
      { label: '', action: '', separator: true },
      { label: 'Settings', action: 'open-settings', shortcut: '⌘,' },
    ],
    Agents: [
      { label: 'My Agents', action: 'open-agents' },
      { label: 'FlzHub', action: 'open-flzhub' },
      { label: 'Store', action: 'open-store' },
    ],
    Skills: [
      { label: 'Skill Store', action: 'open-store' },
      { label: 'My Skills', action: 'open-skills' },
      { label: '', action: '', separator: true },
      { label: 'Run Skill...', action: 'run-skill', shortcut: '⌘R' },
    ],
    Window: [
      { label: 'Minimize', action: 'minimize-window', shortcut: '⌘M' },
      { label: 'Maximize', action: 'maximize-window' },
      { label: '', action: '', separator: true },
      { label: 'Task Manager', action: 'open-task-manager' },
      { label: 'Social', action: 'open-social' },
      { label: 'Research', action: 'open-research' },
      { label: 'Neural Brain', action: 'open-brain' },
    ],
    Help: [
      { label: 'Ask AI', action: 'open-ask-ai', shortcut: '⌘?' },
    ],
  },
  'run-code': {
    File: [
      { label: 'New File', action: 'runcode-new', shortcut: '⌘N' },
      { label: 'Save', action: 'runcode-save', shortcut: '⌘S' },
      { label: '', action: '', separator: true },
      { label: 'Close', action: 'close-window', shortcut: '⌘W' },
    ],
    Edit: [
      { label: 'Undo', action: 'runcode-undo', shortcut: '⌘Z' },
      { label: 'Redo', action: 'runcode-redo', shortcut: '⌘⇧Z' },
      { label: '', action: '', separator: true },
      { label: 'Find', action: 'runcode-find', shortcut: '⌘F' },
    ],
    View: [
      { label: 'Toggle Terminal', action: 'runcode-terminal', shortcut: '⌘`' },
      { label: 'Toggle Diff View', action: 'runcode-diff' },
    ],
    Run: [
      { label: 'Run File', action: 'runcode-run', shortcut: '⌘↵' },
      { label: 'AI Review', action: 'runcode-ai-review' },
    ],
  },
  'run-browser': {
    File: [
      { label: 'New Tab', action: 'browser-new-tab', shortcut: '⌘T' },
      { label: 'Close Tab', action: 'browser-close-tab', shortcut: '⌘W' },
    ],
    View: [
      { label: 'Reload', action: 'browser-reload', shortcut: '⌘R' },
      { label: 'Reader Mode', action: 'browser-reader-mode' },
    ],
    Bookmarks: [
      { label: 'Add Bookmark', action: 'browser-bookmark', shortcut: '⌘D' },
      { label: 'Show History', action: 'browser-history' },
    ],
    Tools: [
      { label: 'Summarize Page', action: 'browser-summarize' },
      { label: 'CDP Mode', action: 'browser-cdp' },
      { label: 'Save to RunFiles', action: 'browser-save-to-files' },
    ],
  },
  'run-files': {
    File: [
      { label: 'Upload File', action: 'files-upload', shortcut: '⌘U' },
      { label: 'New Folder', action: 'files-new-folder', shortcut: '⌘⇧N' },
      { label: '', action: '', separator: true },
      { label: 'Close', action: 'close-window', shortcut: '⌘W' },
    ],
    Edit: [
      { label: 'Select All', action: 'files-select-all', shortcut: '⌘A' },
      { label: '', action: '', separator: true },
      { label: 'Move to Trash', action: 'files-trash-selected', shortcut: '⌘⌫' },
    ],
    View: [
      { label: 'Icon View', action: 'files-icon-view', shortcut: '⌘1' },
      { label: 'List View', action: 'files-list-view', shortcut: '⌘2' },
      { label: '', action: '', separator: true },
      { label: 'Refresh', action: 'files-refresh', shortcut: '⌘R' },
      { label: 'Show Hidden Files', action: 'files-toggle-hidden' },
    ],
    Go: [
      { label: 'Documents', action: 'files-go-documents', shortcut: '⌘1' },
      { label: 'Downloads', action: 'files-go-downloads' },
      { label: 'Images', action: 'files-go-images' },
      { label: 'Music', action: 'files-go-music' },
      { label: 'Videos', action: 'files-go-videos' },
      { label: 'Code', action: 'files-go-code' },
      { label: 'Projects', action: 'files-go-projects' },
      { label: '', action: '', separator: true },
      { label: 'Trash', action: 'files-go-trash' },
    ],
  },
  'run-player': {
    File: [
      { label: 'Open File...', action: 'player-open', shortcut: '⌘O' },
      { label: '', action: '', separator: true },
      { label: 'Close', action: 'close-window', shortcut: '⌘W' },
    ],
    Playback: [
      { label: 'Play / Pause', action: 'player-play-pause', shortcut: '⎵' },
      { label: 'Next', action: 'player-next', shortcut: '⌘→' },
      { label: 'Previous', action: 'player-prev', shortcut: '⌘←' },
      { label: '', action: '', separator: true },
      { label: 'Shuffle', action: 'player-shuffle', shortcut: '⌘S' },
      { label: 'Repeat', action: 'player-repeat', shortcut: '⌘L' },
    ],
    View: [
      { label: 'Show Playlist', action: 'player-toggle-playlist', shortcut: '⌘P' },
      { label: 'Mini Player', action: 'player-mini' },
      { label: '', action: '', separator: true },
      { label: 'Open in RunStudio', action: 'player-open-studio' },
    ],
  },
  'run-sheet': {
    File: [
      { label: 'New Spreadsheet', action: 'sheet-new', shortcut: '⌘N' },
      { label: 'Open...', action: 'sheet-open', shortcut: '⌘O' },
      { label: 'Save', action: 'sheet-save', shortcut: '⌘S' },
      { label: '', action: '', separator: true },
      { label: 'Export as XLSX', action: 'sheet-export-xlsx' },
      { label: 'Export as CSV', action: 'sheet-export-csv' },
      { label: '', action: '', separator: true },
      { label: 'Close', action: 'close-window', shortcut: '⌘W' },
    ],
    Edit: [
      { label: 'Undo', action: 'sheet-undo', shortcut: '⌘Z' },
      { label: 'Redo', action: 'sheet-redo', shortcut: '⌘⇧Z' },
      { label: '', action: '', separator: true },
      { label: 'Find & Replace', action: 'sheet-find', shortcut: '⌘H' },
    ],
    Insert: [
      { label: 'Insert Row', action: 'sheet-insert-row' },
      { label: 'Insert Column', action: 'sheet-insert-col' },
      { label: '', action: '', separator: true },
      { label: 'Insert Chart', action: 'sheet-insert-chart' },
    ],
    AI: [
      { label: 'Suggest Formula', action: 'sheet-ai-formula' },
      { label: 'Analyze Data', action: 'sheet-ai-analyze' },
      { label: 'Generate Chart', action: 'sheet-ai-chart' },
    ],
  },
  'run-docs': {
    File: [
      { label: 'New Document', action: 'docs-new', shortcut: '⌘N' },
      { label: 'Open...', action: 'docs-open', shortcut: '⌘O' },
      { label: 'Save', action: 'docs-save', shortcut: '⌘S' },
      { label: '', action: '', separator: true },
      { label: 'Export as DOCX', action: 'docs-export-docx' },
      { label: 'Export as PDF', action: 'docs-export-pdf' },
      { label: '', action: '', separator: true },
      { label: 'Close', action: 'close-window', shortcut: '⌘W' },
    ],
    Edit: [
      { label: 'Undo', action: 'docs-undo', shortcut: '⌘Z' },
      { label: 'Redo', action: 'docs-redo', shortcut: '⌘⇧Z' },
      { label: '', action: '', separator: true },
      { label: 'Find & Replace', action: 'docs-find', shortcut: '⌘H' },
    ],
    Format: [
      { label: 'Bold', action: 'docs-bold', shortcut: '⌘B' },
      { label: 'Italic', action: 'docs-italic', shortcut: '⌘I' },
      { label: 'Underline', action: 'docs-underline', shortcut: '⌘U' },
    ],
    AI: [
      { label: 'Fix Grammar', action: 'docs-ai-grammar' },
      { label: 'Summarize', action: 'docs-ai-summarize' },
      { label: 'Expand', action: 'docs-ai-expand' },
      { label: 'Translate', action: 'docs-ai-translate' },
    ],
  },
  'run-office': {
    File: [
      { label: 'New Document', action: 'docs-new', shortcut: '⌘N' },
      { label: 'Save', action: 'docs-save', shortcut: '⌘S' },
      { label: '', action: '', separator: true },
      { label: 'Export as DOCX', action: 'docs-export-docx' },
      { label: 'Export as XLSX', action: 'sheet-export-xlsx' },
      { label: '', action: '', separator: true },
      { label: 'Close', action: 'close-window', shortcut: '⌘W' },
    ],
    AI: [
      { label: 'Fix Grammar', action: 'docs-ai-grammar' },
      { label: 'Summarize', action: 'docs-ai-summarize' },
      { label: 'Suggest Formula', action: 'sheet-ai-formula' },
    ],
  },
  'trash': {
    File: [
      { label: 'Empty Trash', action: 'trash-empty' },
      { label: '', action: '', separator: true },
      { label: 'Close', action: 'close-window', shortcut: '⌘W' },
    ],
    Edit: [
      { label: 'Restore Selected', action: 'trash-restore-selected' },
      { label: 'Restore All', action: 'trash-restore-all' },
      { label: '', action: '', separator: true },
      { label: 'Delete Permanently', action: 'trash-delete-permanent' },
    ],
  },
  'run-terminal': {
    File: [
      { label: 'New Terminal', action: 'terminal-new', shortcut: '⌘T' },
      { label: '', action: '', separator: true },
      { label: 'Close', action: 'close-window', shortcut: '⌘W' },
    ],
    Shell: [
      { label: 'Clear', action: 'terminal-clear', shortcut: '⌘K' },
      { label: 'Copy', action: 'terminal-copy', shortcut: '⌘C' },
      { label: 'Paste', action: 'terminal-paste', shortcut: '⌘V' },
    ],
    AI: [
      { label: 'Explain Error', action: 'terminal-explain' },
      { label: 'Fix Error', action: 'terminal-fix' },
      { label: 'Run AI Command', action: 'terminal-ai-run' },
    ],
  },
  'run-music': {
    File: [
      { label: '', action: '', separator: true },
      { label: 'Close', action: 'close-window', shortcut: '⌘W' },
    ],
    Playback: [
      { label: 'Play / Pause', action: 'player-play-pause', shortcut: '⎵' },
      { label: 'Next Track', action: 'player-next', shortcut: '⌘→' },
    ],
    AI: [
      { label: 'Generate with Lyria', action: 'music-generate' },
      { label: 'Open in RunStudio', action: 'player-open-studio' },
    ],
  },
  'run-canvas': {
    File: [
      { label: 'New Canvas', action: 'canvas-new', shortcut: '⌘N' },
      { label: 'Save', action: 'canvas-save', shortcut: '⌘S' },
      { label: '', action: '', separator: true },
      { label: 'Export as PDF', action: 'canvas-export-pdf' },
      { label: 'Export as PNG', action: 'canvas-export-png' },
      { label: 'Export as PPTX', action: 'canvas-export-pptx' },
      { label: '', action: '', separator: true },
      { label: 'Close', action: 'close-window', shortcut: '⌘W' },
    ],
    Edit: [
      { label: 'Undo', action: 'canvas-undo', shortcut: '⌘Z' },
      { label: 'Redo', action: 'canvas-redo', shortcut: '⌘⇧Z' },
      { label: 'Select All', action: 'canvas-select-all', shortcut: '⌘A' },
    ],
    AI: [
      { label: 'Add AI Image', action: 'canvas-ai-image' },
      { label: 'Add Text', action: 'canvas-add-text' },
      { label: 'Suggest Layout', action: 'canvas-ai-layout' },
    ],
  },
  'run-cut': {
    File: [
      { label: 'New Project', action: 'cut-new', shortcut: '⌘N' },
      { label: 'Open Project', action: 'cut-open', shortcut: '⌘O' },
      { label: 'Save', action: 'cut-save', shortcut: '⌘S' },
      { label: '', action: '', separator: true },
      { label: 'Export Video', action: 'cut-export', shortcut: '⌘E' },
      { label: '', action: '', separator: true },
      { label: 'Close', action: 'close-window', shortcut: '⌘W' },
    ],
    Edit: [
      { label: 'Undo', action: 'cut-undo', shortcut: '⌘Z' },
      { label: 'Redo', action: 'cut-redo', shortcut: '⌘⇧Z' },
      { label: '', action: '', separator: true },
      { label: 'Cut', action: 'cut-clip-cut', shortcut: '⌘X' },
      { label: 'Copy', action: 'cut-clip-copy', shortcut: '⌘C' },
      { label: 'Paste', action: 'cut-clip-paste', shortcut: '⌘V' },
      { label: '', action: '', separator: true },
      { label: 'Split Clip', action: 'cut-split', shortcut: '⌘B' },
    ],
    AI: [
      { label: 'Generate Video Clip', action: 'cut-ai-generate' },
      { label: 'Add Subtitles', action: 'cut-ai-subtitles' },
      { label: 'Color Grade', action: 'cut-ai-color-grade' },
      { label: 'Remove Background', action: 'cut-ai-remove-bg' },
    ],
  },
  // --- New window entries ---
  'ask-ai': {
    File: [
      { label: 'New Conversation', action: 'askai-new', shortcut: '⌘N' },
      { label: 'Close', action: 'close-window', shortcut: '⌘W' },
    ],
    View: [
      { label: 'Show History', action: 'askai-history' },
      { label: 'Clear', action: 'askai-clear' },
    ],
    AI: [
      { label: 'Summarize Chat', action: 'askai-summarize' },
      { label: 'Open Tickets', action: 'askai-tickets' },
    ],
  },
  'flzhub': {
    File: [
      { label: 'New Message', action: 'flzhub-new-message', shortcut: '⌘N' },
      { label: 'Close', action: 'close-window', shortcut: '⌘W' },
    ],
    View: [
      { label: 'Anne Filiz', action: 'flzhub-anne' },
      { label: 'Baba Filiz', action: 'flzhub-baba' },
      { label: 'Experts', action: 'flzhub-experts' },
      { label: 'Bebekler', action: 'flzhub-bebekler' },
    ],
    AI: [
      { label: 'Generate Insight', action: 'flzhub-insight' },
    ],
  },
  'social-window': {
    File: [
      { label: 'New Post', action: 'social-new-post', shortcut: '⌘N' },
      { label: 'Close', action: 'close-window', shortcut: '⌘W' },
    ],
    View: [
      { label: 'Feed', action: 'social-feed' },
      { label: 'Explore', action: 'social-explore' },
      { label: 'My Posts', action: 'social-mine' },
    ],
    AI: [
      { label: 'Suggest Post', action: 'social-ai-suggest' },
    ],
  },
  'research-window': {
    File: [
      { label: 'New Project', action: 'research-new', shortcut: '⌘N' },
      { label: 'Close', action: 'close-window', shortcut: '⌘W' },
    ],
    View: [
      { label: 'My Projects', action: 'research-mine' },
      { label: 'Findings', action: 'research-findings' },
    ],
    AI: [
      { label: 'Run Web Search', action: 'research-web-search' },
      { label: 'Summarize Paper', action: 'research-summarize' },
    ],
  },
  'agents-window': {
    File: [
      { label: 'New Agent', action: 'agents-new' },
      { label: 'Close', action: 'close-window', shortcut: '⌘W' },
    ],
    View: [
      { label: 'My Agents', action: 'agents-mine' },
      { label: 'A2A Connections', action: 'agents-a2a' },
    ],
    AI: [
      { label: 'Match Agent', action: 'agents-match' },
    ],
  },
  'neural-brain': {
    File: [
      { label: 'New Wiki Page', action: 'brain-new', shortcut: '⌘N' },
      { label: 'Save', action: 'brain-save', shortcut: '⌘S' },
      { label: 'Close', action: 'close-window', shortcut: '⌘W' },
    ],
    Edit: [
      { label: 'Find', action: 'brain-find', shortcut: '⌘F' },
    ],
    View: [
      { label: 'All Pages', action: 'brain-all' },
      { label: 'Recent', action: 'brain-recent' },
    ],
    AI: [
      { label: 'Generate Page', action: 'brain-ai-generate' },
      { label: 'Improve Selection', action: 'brain-ai-improve' },
    ],
  },
  'os-settings': {
    File: [
      { label: 'Close', action: 'close-window', shortcut: '⌘W' },
    ],
    View: [
      { label: 'General', action: 'settings-general' },
      { label: 'Theme', action: 'settings-theme' },
      { label: 'Voice', action: 'settings-voice' },
      { label: 'Plan', action: 'settings-plan' },
    ],
    AI: [
      { label: 'Suggest Settings', action: 'settings-ai-suggest' },
    ],
  },
  'task-manager': {
    File: [
      { label: 'New Task', action: 'task-new', shortcut: '⌘N' },
      { label: 'Close', action: 'close-window', shortcut: '⌘W' },
    ],
    View: [
      { label: 'Eisenhower Grid', action: 'task-eisenhower' },
      { label: 'List', action: 'task-list' },
      { label: 'Kanban', action: 'task-kanban' },
    ],
    AI: [
      { label: 'Auto-categorize', action: 'task-ai-categorize' },
      { label: 'Prioritize Today', action: 'task-ai-prioritize' },
    ],
  },
  'twin': {
    File: [
      { label: 'Close', action: 'close-window', shortcut: '⌘W' },
    ],
    View: [
      { label: 'Persona', action: 'twin-persona' },
      { label: 'Memories', action: 'twin-memories' },
      { label: 'Bond', action: 'twin-bond' },
      { label: 'Curiosity', action: 'twin-curiosity' },
    ],
    AI: [
      { label: 'Ask My Twin', action: 'twin-ask' },
      { label: 'Train', action: 'twin-train' },
    ],
  },
  'runai-pad': {
    File: [
      { label: 'New Note', action: 'pad-new', shortcut: '⌘N' },
      { label: 'Save', action: 'pad-save', shortcut: '⌘S' },
      { label: 'Export Markdown', action: 'pad-export-md' },
      { label: 'Close', action: 'close-window', shortcut: '⌘W' },
    ],
    Edit: [
      { label: 'Undo', action: 'pad-undo', shortcut: '⌘Z' },
      { label: 'Find', action: 'pad-find', shortcut: '⌘F' },
    ],
    View: [
      { label: 'Preview', action: 'pad-preview' },
    ],
    AI: [
      { label: 'Improve Writing', action: 'pad-ai-improve' },
      { label: 'Summarize', action: 'pad-ai-summarize' },
    ],
  },
  'run-image': {
    File: [
      { label: 'New Generation', action: 'image-new', shortcut: '⌘N' },
      { label: 'Save to RunFiles', action: 'image-save' },
      { label: 'Close', action: 'close-window', shortcut: '⌘W' },
    ],
    View: [
      { label: 'Gallery', action: 'image-gallery' },
      { label: 'History', action: 'image-history' },
    ],
    AI: [
      { label: 'Generate (FLUX)', action: 'image-ai-generate' },
      { label: 'Upscale', action: 'image-ai-upscale' },
    ],
  },
  'run-buzz': {
    File: [
      { label: 'New Post', action: 'buzz-new', shortcut: '⌘N' },
      { label: 'Schedule', action: 'buzz-schedule' },
      { label: 'Close', action: 'close-window', shortcut: '⌘W' },
    ],
    View: [
      { label: 'Drafts', action: 'buzz-drafts' },
      { label: 'Scheduled', action: 'buzz-scheduled' },
      { label: 'Analytics', action: 'buzz-analytics' },
    ],
    AI: [
      { label: 'Generate Caption', action: 'buzz-ai-caption' },
      { label: 'Best Time to Post', action: 'buzz-ai-time' },
    ],
  },
}
